module.exports = __webpack_public_path__ + "assets/images/map.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/map.png
// module id = 1516
// module chunks = 1